import type { HierarchyRectangularNode } from 'd3-hierarchy';

import {
  NODE_LEAF_PADDING,
  NODE_CLUSTER_PADDING,
  NODE_WITH_RECT_CLUSTER_PADDING,
  NODE_WITH_RECT_PADDING_TOP,
  ROOT_NODE_WITH_LABELS_OUTER_PADDING,
  NODE_WITH_RECT_OUTER_PADDING,
} from '../constants.js';
import { type InternalTreeMapNode } from '../types/internal.js';

export function nodePadding<TTreeNode>(
  node: HierarchyRectangularNode<TTreeNode>,
  hasParentLabel: boolean,
): number {
  if (node.height === 0) {
    return NODE_LEAF_PADDING;
  }

  if (hasParentLabel) {
    return node.depth > 0
      ? NODE_CLUSTER_PADDING
      : NODE_WITH_RECT_CLUSTER_PADDING;
  }

  return NODE_CLUSTER_PADDING;
}

export const nodePaddingTop = (
  node: HierarchyRectangularNode<InternalTreeMapNode>,
): number => {
  return node.depth > 0
    ? NODE_WITH_RECT_PADDING_TOP
    : ROOT_NODE_WITH_LABELS_OUTER_PADDING;
};

export const nodePaddingOuter = (
  node: HierarchyRectangularNode<InternalTreeMapNode>,
): number => {
  return node.depth > 0
    ? NODE_WITH_RECT_OUTER_PADDING
    : ROOT_NODE_WITH_LABELS_OUTER_PADDING;
};
